var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v("Taxa")]),_c('ul',_vm._l((_vm.TAXA),function(taxon){return _c('li',{key:taxon.comName},[_vm._v("\n      "+_vm._s(taxon.comName)+"\n    ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }